import { useArtists } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { ArtistCard } from '../ArtistCard';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import type { Artist } from '@/types';

export function ArtistStep() {
  const { data: artists, isLoading, error } = useArtists();
  const navigate = useNavigate();

  const openArtists = artists?.filter(a => a.status !== 'closed') || [];

  const handleSelect = (artist: Artist) => navigate(`/commission/${artist.slug}`);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500 mb-4">Failed to load artists</p>
        <button
          onClick={() => window.location.reload()}
          className="text-[var(--color-primary)] hover:underline"
        >
          Try again
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 data-step-heading tabIndex={-1} className="text-2xl font-bold text-[var(--color-text)]">
          Choose Your Artist
        </h2>
        <p className="text-[var(--color-text-muted)] mt-2">
          Select an artist to see their pricing and options
        </p>
      </div>

      {openArtists.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {openArtists.map(artist => (
            <ArtistCard
              key={artist.id}
              artist={artist}
              selected={false}
              onSelect={() => handleSelect(artist)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-10">
          <p className="text-[var(--color-text-muted)]">
            No artists available for commissions at this time.
          </p>
          <p className="text-sm text-[var(--color-text-muted)] mt-2">
            Please check back later or follow us on social media for updates.
          </p>
        </div>
      )}
    </div>
  );
}
